import { useState, useEffect } from 'react';
import cn from 'classnames';
import Marquee from 'react-fast-marquee';
import Image from 'next/image';
import { Container } from 'react-scale/components/pages/zeitgeist/layout/container';
import { CTA } from 'react-scale/components/pages/zeitgeist/primitives/cta';
import HubspotForm from 'react-hubspot-form';

import s from './download.module.scss';
import { useMedia } from 'react-use';
import { Drawer } from '../../layout/drawer';
import { FC } from 'react';

export const Download: FC<{ form?: boolean }> = ({ form }) => {
  const [formLoaded, setFormLoaded] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const isDesktop = useMedia('(min-width: 1024px)');

  const formId = form
    ? '32ee0763-f323-441e-8cd6-c2d2cef9d142'
    : 'c45678a3-2454-4617-815f-5d0af56b08db';

  useEffect(() => {
    const hubSpotEventHandler = async event => {
      const data = event?.data;

      if (data && data.type === 'hsFormCallback' && data.eventName === 'onFormSubmit') {
        if (data.id === formId) {
          setFormSubmitted(true);
        }
      }
    };

    window.addEventListener('message', hubSpotEventHandler);

    return () => window.removeEventListener('message', hubSpotEventHandler);
  }, []);

  return (
    <Container size="sm" className={s['container']}>
      <div className={s['section']}>
        <div className={s['marquee__wrapper']}>
          <Marquee gradient={false} speed={isDesktop ? 100 : 40}>
            <h5 className={s['marquee__text']}>DOWNLOAD</h5>
            <Image
              src="/static/zeitgeist/2023/zeitgeist-logo.svg"
              className={s['logo']}
              width={113}
              height={113}
              alt="Zeitgeist logo"
              quality={100}
            />
            <h5 className={s['marquee__text']}>REPORT</h5>
            <Image
              src="/static/zeitgeist/2023/zeitgeist-box.svg"
              className={s['logo']}
              width={113}
              height={113}
              alt="Zeitgeist box"
              quality={100}
            />
            <h5 className={s['marquee__text']}>DOWNLOAD</h5>
            <Image
              src="/static/zeitgeist/2023/zeitgeist-logo.svg"
              className={s['logo']}
              width={113}
              height={113}
              alt="Zeitgeist logo"
              quality={100}
            />
            <h5 className={s['marquee__text']}>REPORT</h5>
            <Image
              src="/static/zeitgeist/2023/zeitgeist-box.svg"
              className={s['logo']}
              width={113}
              height={113}
              alt="Zeitgeist box"
              quality={100}
            />
          </Marquee>
        </div>

        <div className={cn(s['form__wrapper'], !form && 'justify-center')}>
          <p className={s['form__paragraph']}>
            Download the report to look past the hype and see what it really takes to adopt
            Generative AI to help you solve your most important business&nbsp;challenges.
          </p>

          {form ? (
            <div
              className={cn(
                s['form'],
                formLoaded && '!h-auto',
                !form ? s['form--long'] : s['form--short']
              )}
            >
              <div
                className={cn(
                  !formSubmitted ? 'opacity-100' : 'opacity-0 absolute w-full',
                  'transition-opacity duration-700 ease-out'
                )}
              >
                <HubspotForm
                  onReady={() => setFormLoaded(true)}
                  portalId="4823527"
                  formId={formId}
                  formInstanceId="download-section-form"
                />
              </div>
              <p
                className={cn(
                  s['submitted-message'],
                  formSubmitted
                    ? 'opacity-100 delay-700'
                    : 'absolute opacity-0 pointer-events-none',
                  'transition-opacity duration-700 ease-out'
                )}
              >
                Thank you for your interest in our 2023 AI Readiness Report. Please check your inbox
                to access the full&nbsp;report.
              </p>
              <CTA
                arrow="right"
                className={cn(
                  formSubmitted ? 'absolute opacity-0 pointer-events-none' : 'opacity-100',
                  'transition-opacity duration-700 ease-out'
                )}
                onClick={() =>
                  (
                    document.querySelector(
                      `form#hsForm_${formId}_download-section-form > * input.hs-button`
                    ) as HTMLInputElement
                  ).click()
                }
              >
                SUBMIT
              </CTA>
            </div>
          ) : (
            <Drawer
              trigger={
                <CTA arrow="bottom" className={s['cta--download']}>
                  Download the full report
                </CTA>
              }
            />
          )}
        </div>
      </div>
    </Container>
  );
};
